import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Input, Radio, RadioChangeEvent, Row, Select, Space } from "antd";

import AddressMaker, { AddressType } from "./AddressMaker";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterInformationTitle({
    editMode,
    currentInformationTitle,
    onRegisterInformationTitle,
}: {
    editMode: string;
    currentInformationTitle?: Types.InformationTitleDto;
    onRegisterInformationTitle?: () => void;
}) {
    const [form] = Form.useForm();
    const alert = useAlert();

    const [informationTitleId, setInformationTitleId] = useState("");
    const [unavailable, setunavailable] = useState("");
    const [informationTitle, setInformationTitle] = useState("");

    const requestAxiosAddInformationTitle = async (data: Types.InformationTitleDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().post(Request.INFORMATION_TITLE_URL, data);

        return response.data;
    };

    const {
        loading: loadingAddInformationTitle,
        error: errorAddInformationTitle,
        data: resultAddInformationTitle,
        execute: requestAddInformationTitle,
    } = useAsyncAxios(requestAxiosAddInformationTitle);

    useEffect(() => {
        if (currentInformationTitle === undefined) return;

        form.setFieldsValue(currentInformationTitle);
    }, [currentInformationTitle]);

    useEffect(() => {
        if (resultAddInformationTitle === null) return;

        if (onRegisterInformationTitle) onRegisterInformationTitle();

        alert.setAlert(AlertType.SUCCESS, "주요 안내 주제 추가 성공", "주요 안내 주제 추가를 완료하였습니다.");
    }, [resultAddInformationTitle]);

    useEffect(() => {
        if (errorAddInformationTitle === null) return;

        console.log("errorInformationTitle", errorAddInformationTitle);
        alert.setAlert(errorAddInformationTitle.response.data.code, "주요 안내 주제 추가 실패", errorAddInformationTitle.response.data.message);
    }, [errorAddInformationTitle]);

    const requestAxiosUpdateInformationTitle = async (data: Types.InformationTitleDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().put(Request.INFORMATION_TITLE_URL + "/" + data.informationTitleId, data);

        return response.data;
    };

    const {
        loading: loadingUpdateInformationTitle,
        error: errorUpdateInformationTitle,
        data: resultUpdateInformationTitle,
        execute: requestUpdateInformationTitle,
    } = useAsyncAxios(requestAxiosUpdateInformationTitle);

    useEffect(() => {
        if (resultUpdateInformationTitle === null) return;

        if (onRegisterInformationTitle) onRegisterInformationTitle();

        alert.setAlert(AlertType.SUCCESS, "주요 안내 주제 수정 성공", "주요 안내 주제 수정을 완료하였습니다.");
    }, [resultUpdateInformationTitle]);

    useEffect(() => {
        if (errorUpdateInformationTitle === null) return;

        console.log("errorUpdateInformationTitle", errorUpdateInformationTitle);
        alert.setAlert(errorUpdateInformationTitle.response.data.code, "주요 안내 주제 수정 실패", errorUpdateInformationTitle.response.data.message);
    }, [errorUpdateInformationTitle]);

    const onFinish = (values: any) => {
        delete values["confirm"];
        const data: Types.InformationTitleDto = {
            ...values,
        };
        console.log("Received values of form: ", data);

        if (editMode === "add") requestAddInformationTitle(data);
        else if (editMode === "update") requestUpdateInformationTitle(data);
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="informationTitleId" label="주요 안내 주제 ID">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="informationTitle"
                                label="주요 안내 주제"
                                rules={[
                                    {
                                        required: true,
                                        message: "주요 안내 주제를 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="주요 안내 주제 이름을 입력해 주세요." onChange={(e) => setInformationTitle(e.target.value)} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RegisterInformationTitle;
